module.exports = __webpack_public_path__ + "img/36.e13d16f9.jpg";